var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('v-select',{attrs:{"outlined":"","rounded":"","dense":"","height":_vm.height,"hide-details":"auto","placeholder":"請選擇","items":_vm.items,"value":_vm.value,"item-text":"label","item-value":"value","clearable":_vm.clearable,"disabled":_vm.disabled,"error-messages":_vm.errorsMsg},on:{"change":_vm.onchange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }